import React, { useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import SupportRequestModal from './SupportRequestModal';
import './support.css';

const ELEVATED_ROUTE_PREFIXES = ['/menu/', '/cart', '/orders'];

function isMapRoute(pathname) {
  return pathname === '/' || pathname === '';
}

function isElevatedRoute(pathname) {
  return ELEVATED_ROUTE_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

const SupportRequestFab = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const fabClassName = useMemo(() => {
    const classes = ['support-fab'];
    if (isMapRoute(location.pathname)) {
      classes.push('support-fab--above-map-cart');
    } else if (isElevatedRoute(location.pathname)) {
      classes.push('support-fab--elevated');
    }
    return classes.join(' ');
  }, [location.pathname]);

  return (
    <>
      <button
        type="button"
        className={fabClassName}
        onClick={() => setIsOpen(true)}
        aria-label="Обращение в поддержку"
        title="Поддержка"
      >
        <span className="support-fab-icon" aria-hidden="true">
          ?
        </span>
      </button>
      <SupportRequestModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export default SupportRequestFab;
